import { Skeleton } from '@/components/ui/skeleton.tsx'
import { SkeletonAccordion } from '@/components/shared/loading/accordion.tsx'

export const SkeletonPageLoading = () => (
  <div className={`fixed bottom-0 left-0 right-0 top-0 z-10 flex h-screen w-screen flex-col overflow-hidden bg-white`}>
    <nav className={`flex items-center justify-between border border-b-gray-200 bg-white px-6 py-3`}>
      <div className={`flex items-center gap-6`}>
        <Skeleton className='flex h-10 w-10 items-center justify-center rounded-lg' />
        <Skeleton className='h-10 w-40 rounded-md' />
      </div>
      <div className={`flex items-center gap-4`}>
        <Skeleton className='h-10 w-52 rounded-md' />
        <Skeleton className='h-10 w-44 rounded-md' />
      </div>
    </nav>
    <section className={`grid h-[calc(100vh-64px)] grid-cols-[300px_auto]`}>
      <div className={`flex flex-col gap-4 overflow-y-auto bg-white p-6`}>
        <Skeleton className='h-20 w-full rounded-md' />
        <SkeletonAccordion defaultOpen />
      </div>
      <div className={`flex h-full flex-col items-center gap-8 bg-gray-50 px-14 pt-4`}>
        <Skeleton className='flex h-10 w-60 gap-1 rounded-3xl bg-white p-2 shadow-loose-plus'>
          <Skeleton className='h-full w-20 rounded-full' />
        </Skeleton>
        <Skeleton className='h-[54vh] w-full rounded-xl bg-white' />
      </div>
    </section>
  </div>
)
